import React from "react"

function IconTachometer({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="tachometer"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-tachometer"
      {...props}
    >
      <path
        d="M11.865 1.92c5.493 0 9.945 4.453 9.945 9.945s-4.452 9.945-9.945 9.945c-5.492 0-9.945-4.453-9.945-9.945S6.373 1.92 11.865 1.92zm.647 1.333v1.249a.655.655 0 0 1-1.3.106l-.008-.106V3.254a8.618 8.618 0 0 0-5.888 2.982l.917.762a.655.655 0 0 1-.75 1.068l-.087-.061-.858-.713a8.636 8.636 0 1 0 14.649-.008l-.867.721-.087.061a.655.655 0 0 1-.833-.984l.083-.084.925-.77a8.617 8.617 0 0 0-5.896-2.975zm2.558 3.28c.277.17.383.514.263.806l-.048.095-1.463 2.377a2.836 2.836 0 1 1-1.131-.66l1.479-2.403a.655.655 0 0 1 .9-.215zm-3.205 3.805a1.527 1.527 0 1 0 0 3.055 1.527 1.527 0 0 0 0-3.055z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconTachometer
